<template>
  <div class="inline-flex">
    <div
      v-if="loading"
      class="px-4 inline-flex h-12 focus:outline-none items-center justify-center text-white bg-white"
    >
      <Loader small />
    </div>
    <template v-else-if="resolved">
      <button
        v-if="conversation"
        class="px-4 inline-flex h-12 focus:outline-none items-center justify-center text-white bg-blue-600 hover:bg-blue-500"
        @click="openConversation"
      >
        Open conversation
      </button>
      <button
        v-else
        class="px-4 inline-flex h-12 focus:outline-none items-center justify-center text-white bg-blue-600 hover:bg-blue-500"
        @click="startConversation"
      >
        Start conversation
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId];
    },
    conversation() {
      return this.$store.getters['ui/projectConversation/itemByParent'](this.projectId);
    },
  },
  created() {
    this.fetchConversation();
  },
  methods: {
    async fetchConversation() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/projectConversation/load', {
          projectId: this.projectId,
          query: {
            include: 'participants.participable',
          },
        });
        this.resolved = true;
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
    async startConversation() {
      try {
        this.loading = true;
        await this.$store.dispatch('ui/projectConversation/store', {
          projectId: this.projectId,
        });

        this.openConversation();
        this.resolved = true;
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
    openConversation() {
      this.$modal.show({
        component: 'ConversationModal',
        props: {
          conversationId: this.conversation?.id,
        },
        hideEvent: 'closed',
      });
    },
  },
};
</script>
